import "./OurPartners.css"

const OurPartners = () => {
  return (
    <div>
      <div className="about-ourpartners">
        <div className="ourpartners-heading" data-aos="fade-up"
          data-aos-duration="1000">
          <h3>OUR national PARTNERS</h3>
          <hr />
        </div>
        <div className="ourpartners-img" data-aos="fade-up"
          data-aos-duration="1000">
          <img src="./HomePhotos/OurNationalPartners/ourpartners1.png" alt="partners" />
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners2.png" alt="partners" style={{ width: '170px' }} />
          <img src="./HomePhotos/OurNationalPartners/ourpartners3.png" alt="partners" /> */}
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners4.jpeg" alt="partners" /> */}
          <img src="./HomePhotos/OurNationalPartners/avenueone.png" alt="partners" style={{ width: '170px' }} />
          <img src="./HomePhotos/OurNationalPartners/ourpartners5.jpeg" alt="partners" style={{ width: '170px' }} />
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners6.png" alt="partners" style={{ width: '170px' }} /> */}
          <img src="./HomePhotos/OurNationalPartners/ourpartners7.png" alt="partners" style={{ width: '170px' }} />
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners8.png" alt="partners" style={{ width: '170px' }} /> */}
          <img src="./HomePhotos/OurNationalPartners/ashirdeveloper.png" alt="partners" style={{ width: '170px' }} />
        </div>
      </div>
    </div>
  )
}

export default OurPartners